import { render } from "./catalogMenuSkeleton.vue?vue&type=template&id=75d60758"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__